module.exports = __webpack_public_path__ + "static/media/YM01_1.a4c91f7a.jpg";